export default __webpack_public_path__ + "static/media/logo.c5d69c79.svg";